module.exports = __webpack_public_path__ + "static/img/bg43.d408347b.png";